<template>
  <div class="add-package">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="goPackageManage">套餐管理/</span>
        <span v-if="id">修改套餐</span>
        <span v-else>新增套餐</span>
      </template>
      <template v-slot:content>
        <div class="add-package-main">
          <div class="table-img">
            <el-table :data="tableData" :span-method="objectSpanMethod">
              <el-table-column label="图片" width="100">
                <template slot-scope="scope">
                  <el-image class="img" :src="scope.row.img" lazy></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="商品名称">
                <template slot-scope="scope">
                  <p class="name" :title="scope.row.name">{{ scope.row.name }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="specifications" label="规格"></el-table-column>
              <el-table-column prop="price" label="市场价" width="100"></el-table-column>
              <el-table-column prop="number" label="数量">
                <template slot-scope="scope">
                  <el-input class="white" v-model="scope.row.number"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="isShow" label="是否显示套餐">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.isShow"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="remove(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="discountAmount" label="优惠金额">
                <template slot-scope="scope">
                  <el-input
                  class="white"
                  v-model="scope.row.discountAmount"
                  @input="inputDisconutAmount(scope.$index, scope.row.discountAmount)" 
                  :disabled="form.fixedPrice"></el-input>
                </template>
              </el-table-column>
              <!-- <el-table-column label="总金额" class="border">
                <template>
                  <p class="totlePrice">{{totlePrice}}</p>
                </template>
              </el-table-column> -->
              <el-table-column label="套餐价">
                <template slot-scope="scope">
                  <el-input :class="scope.row.id?'white':'white'" v-model="packagePrice" :disabled="!form.fixedPrice"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="游客价增量">
                <template slot-scope="scope">
                  <el-input :class="scope.row.id?'white':'white'" v-model="touristPrice"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="add table-img" ref="steps">
            <el-button class="btn-text" type="text" @click="addGoods">添加商品</el-button>
            <el-dialog title="添加商品" :visible.sync="dialogTableVisible" width="1200px" top="20vh">
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <!-- 表格部分 -->
              <div class="input-search">
                <el-cascader
                  clearable
                  class="gray w160"
                  v-model="dialogForm.classify"
                  :options="classify"
                  :props="defaultParams"
                  placeholder="请选择分类"
                  filterable
                  :show-all-levels="false"
                ></el-cascader>
                <el-input
                  class="gray"
                  placeholder="请输入商品名称/商品编码"
                  @keyup.enter.native="search"
                  v-model="dialogForm.codeName"
                ></el-input>
                <el-button type="text" class="btn-blue" @click="search">搜索</el-button>
              </div>
              <el-table
                height="260"
                :data="dialogTableData"
                ref="dialogTable"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="35"></el-table-column>
                <el-table-column label="商品图片" width="100">
                  <template slot-scope="scope">
                    <img :src="scope.row.img" class="img" />
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" width="200">
                  <template slot-scope="scope">
                    <p class="name">{{ scope.row.name }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="specifications" label="商品规格">
                  <!-- 选择器 -->
                  <template slot-scope="scope">
                    <p class="list" v-for="(value,index) in scope.row.specifications" :key="index">
                      <span>{{value.title}}：</span>
                      <el-select
                        v-model="value.value"
                        class="gray"
                        @change="changeSku(scope.$index)"
                      >
                        <el-option
                          v-for="item in value.options"
                          :key="item.name"
                          :value="item.name"
                        ></el-option>
                      </el-select>
                    </p>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="价格" width="150"></el-table-column>
              </el-table>
              <div class="table_pagination">
                <PaginationModul :total="total" :currentPage="page" @queryChange="updatePage"></PaginationModul>
              </div>
              <div id="footer">
                <!-- 取消关闭对话框 -->
                <el-button class="btn-white" @click="dialogTableVisible = false">取 消</el-button>
                <!-- 修改保存 -->
                <el-button class="btn-blue" type="primary" @click="save(dialogTableData)">确 定</el-button>
              </div>
            </el-dialog>
          </div>
          <el-form :model="form" label-width="80px" class="form">
            <el-form-item label="套餐名称：">
              <el-input v-model="form.name" class="gray"></el-input>
            </el-form-item>
            <el-form-item label="是否启用：">
              <el-radio v-model="form.status" :label="true">开启</el-radio>
              <el-radio v-model="form.status" :label="false">关闭</el-radio>
            </el-form-item>
            <el-form-item label="一口价：">
              <el-radio v-model="form.fixedPrice" :label="true">开启</el-radio>
              <el-radio v-model="form.fixedPrice" :label="false">关闭</el-radio>
            </el-form-item>
          </el-form>
          <div class="bottom">
            <div class="operations" ref="operations">
              <el-button class="btn-white" @click="goPackageManage">取消</el-button>
              <el-button class="btn-blue" @click="saveData">保存</el-button>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationModul from "base/PaginationTpl";
import DBCommodity from "models/db/commodity.js";
import DBMarketing from "models/db/marketing.js";
const dbCommodity = new DBCommodity();
const dbMarketing = new DBMarketing();
export default {
  data() {
    return {
      id: "",
      tableData: [
        // {
        //   id: 12,
        //   img:
        //     'http://img3.imgtn.bdimg.com/it/u=3864086826,2415830551&fm=26&gp=0.jpg',
        //   name:
        //     '哈哈哈哈哈哈哈哈哈哈或或或或或或或或或或或或或或哈哈哈哈哈哈哈哈',
        //   price: 1234,
        //   number: 1,
        //   status: true
        // }
      ],
      form: {
        name: "",
        status: true,
        fixedPrice: true
      },
      dialogForm: {
        classify: [],
        codeName: ""
      },
      dialogFormSearch: {
        classify: [],
        codeName: ""
      },
      classify: [], // 分类数据
      defaultParams: {
        label: "cateName",
        value: "id",
        children: "children"
      },
      dialogTableData: [],
      dialogTable: "",
      totlePrice: 0,
      packagePrice: "",
      touristPrice: "",
      page: 1,
      total: 0,
      pageSize: 20,
      dialogTableVisible: false
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationModul
  },
  watch: {
    tableData: {
      handler(newVal, oldVal) {
        this.totlePrice = 0
        let packagePrice = 0
        newVal.map(val => {
          let price = (val.price * 100 * Number(val.number)) / 100;
          let num = (((Number(val.price) * 100 - Number(val.discountAmount) *100)/100) * val.number)
          this.totlePrice += price;
          packagePrice += num
          if (!this.form.fixedPrice) {
            this.packagePrice = packagePrice
          }
        });
      },
      deep: true
    }
  },
  beforeMount() {
    this.getGoodsClassify();
    this.getGoods();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getData(this.id);
    }
  },
  mounted() {
    const paddingWidth = 48;
    this.$refs.operations.style.width =
      this.$refs.steps.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      if (this.$refs.operations) {
        this.$refs.operations.style.width =
          this.$refs.steps.clientWidth + paddingWidth + "px";
      }
    };
  },
  methods: {
    // 限制优惠金额的输入
    inputDisconutAmount(index, price) {
      if (price == '.') {
        price = ''
      }
      let RetailPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.$set(this.tableData[index], "discountAmount", RetailPrice);
    },
    // 返回上一页
    goPackageManage() {
      this.$router.push("/admin/marketing/package-index/package-manage");
    },
    // 表格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8 || columnIndex === 9) {
        let length = this.tableData.length + 1;
        if (rowIndex % length === 0) {
          return {
            rowspan: length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 判断挡墙页是否存在id并获取当前数据
    getData(id) {
      dbMarketing.getDBDetailPackage(id).then(res => {
        if (res.success) {
          this.totlePrice = res.result.setMeal.oldPrice;
          this.packagePrice = res.result.setMeal.price;
          this.touristPrice = res.result.setMeal.visitorIncrement;
          this.form.name = res.result.setMeal.title;
          this.form.status = res.result.setMeal.status === 100;
          this.form.fixedPrice = res.result.setMeal.isFixedPrice === 1 ? true : false
          let arr = [];
          res.result.setMealGoodsList.map(value => {
            let obj = {};
            obj.id = value.itemId;
            obj.img = value.goodsPic;
            obj.name = value.goodsName;
            obj.price = value.marketPrice;
            obj.number = value.quantity;
            obj.goodsId = value.goodsId;
            obj.isShow = value.isShow === 1;
            obj.discountAmount = value.discountedPrice
            let str = "";
            Object.keys(JSON.parse(value.itemTitle)).forEach(function(key) {
              console.log();
              str += JSON.parse(value.itemTitle)[key] + ";";
            });
            obj.specifications = str.slice(0, str.length - 1);

            arr.push(obj);
          });
          this.tableData = arr;
        }
      });
    },
    // 获取商品分类列表
    getGoodsClassify() {
      dbCommodity.getDBGoodsClassify().then(res => {
        if (res.success) {
          this.classify = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取商品列表
    getGoods() {
      let length = this.dialogFormSearch.classify.length - 1;
      let category1Id = this.dialogFormSearch.classify[length]
        ? this.dialogFormSearch.classify[length]
        : "";
      let goodsName = this.dialogFormSearch.codeName
        ? this.dialogFormSearch.codeName
        : "";
      let currentPage = this.page;
      let options = {
        category1Id,
        goodsName,
        currentPage
      };
      dbCommodity.getCommodityListWithNorm(options).then(res => {
        this.total = res.result.totalNum;
        if (res.success) {
          let arr = [];
          res.result.items.map((value, index, array) => {
            let obj = {};
            obj.name = value.goodsName;
            obj.img = value.itemImages[0];
            obj.classify = value.categoryName;
            obj.goodsId = value.id;
            obj.items = value.items;
            obj.price = value.items[0].marketPrice;
            let specificationItems = value.specificationItems;
            let Arr = [];
            specificationItems.map(v => {
              let object = {};
              object.title = v.name;
              object.value = v.value[0];
              object.options = [];
              v.value.map(val => {
                let objOptions = {};
                objOptions.name = val;
                object.options.push(objOptions);
              });
              Arr.push(object);
            });
            obj.specifications = Arr;
            arr.push(obj);
          });
          this.dialogTableData = arr;
        }
      });
    },
    // 点击添加按钮
    addGoods() {
      this.dialogTableVisible = true;
      if (this.dialogTable) {
        this.$refs.dialogTable.clearSelection();
      }
    },
    // 搜索商品
    search() {
      this.dialogFormSearch = this.dialogForm;
      this.getGoods();
    },
    // 选中表格
    handleSelectionChange(val) {
      this.dialogTable = val;
    },
    // 弹窗点击保存
    save() {
      let length = this.tableData.length + this.dialogTable.length;
      if (length > 5) {
        this.$message.error("最多添加5个商品");
      } else {
        // 整理表格
        let data = [];
        this.dialogTable.map((value, index, array) => {
          let object = {};
          object.name = value.name;
          object.img = value.img;
          object.number = 1;
          object.discountAmount = 0;
          object.goodsId = value.goodsId;
          object.price = value.price;
          object.isShow = true;
          let obj = {};
          let str = "";
          value.specifications.map(v => {
            obj[v.title] = v.value;
            str += v.value + ";";
          });
          object.specifications = str.slice(0, str.length - 1);
          value.items.map(v => {
            let specInfo = {};
            value.specifications.map(val => {
              specInfo[val.title] = v.specInfo[val.title];
            });
            if (JSON.stringify(specInfo) === JSON.stringify(obj)) {
              object.id = v.id;
            }
          });
          data.push(object);
        });
        let table = this.tableData.concat(data);
        let newTable = [];
        for (var i = 0; i < table.length; i++) {
          var flag = true;
          for (var j = 0; j < newTable.length; j++) {
            if (table[i].id === newTable[j].id) {
              flag = false;
            }
          }
          if (flag) {
            newTable.push(table[i]);
          }
        }
        this.tableData = newTable;
        console.log(this.tableData);
        this.$message.success("添加成功");
      }
    },
    // sku价格变化
    changeSku(index) {
      console.log(this.dialogTableData[index]);
      let obj = {};
      this.dialogTableData[index].specifications.map(value => {
        obj[value.title] = value.value;
      });
      this.dialogTableData[index].items.map(value => {
        if (JSON.stringify(value.specInfo) === JSON.stringify(obj)) {
          this.dialogTableData[index].price = value.marketPrice;
        }
      });
    },
    remove(index) {
      this.tableData.splice(index, 1);
    },
    // 跳转页码
    updatePage(data) {
      this.page = data.currentPage;
      this.getGoods();
    },
    // 保存数据
    saveData() {
      if (this.tableData.length === 0) {
        this.$message.error("请添加商品");
        return;
      } else if (this.packagePrice === "") {
        this.$message.error("请输入套餐价");
        return;
      } else if (this.form.name === "") {
        this.$message.error("请输入套餐名称");
        return;
      } else if (this.packagePrice <= 0) {
        this.$message.error("套餐价必须大于0");
        return;
      }
      if (this.id) {
        let data = {};
        data.title = this.form.name;
        data.price = this.packagePrice;
        data.visitorIncrement = this.touristPrice === ''?0:Number(this.touristPrice);
        data.id = this.id;
        data.status = this.form.status ? 100 : 200;
        data.isFixedPrice = this.form.fixedPrice ? 1 : 0
        data.setMealGoodsList = [];
        this.tableData.map(value => {
          let obj = {};
          obj.goodsId = value.goodsId;
          obj.itemId = value.id;
          obj.quantity = value.number;
          obj.isShow = value.isShow ? 1 : 0;
          obj.discountedPrice = value.discountAmount
          data.setMealGoodsList.push(obj);
        });
        dbMarketing.getDBUpdatePackage(data).then(res => {
          if (res.success) {
            this.$message.success("修改成功");
            this.$router.push({
              name: "package-manage",
              params: {
                packageChange: true
              }
            });
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        let data = {};
        data.title = this.form.name;
        data.price = this.packagePrice;
        data.visitorIncrement = this.touristPrice === ''?0:Number(this.touristPrice);
        data.status = this.form.status ? 100 : 200;
        data.isFixedPrice = this.form.fixedPrice ? 1 : 0
        data.setMealGoodsList = [];
        this.tableData.map(value => {
          let obj = {};
          obj.goodsId = value.goodsId;
          obj.itemId = value.id;
          obj.quantity = value.number;
          obj.isShow = value.isShow ? 1 : 0;
          obj.discountedPrice = value.discountAmount
          data.setMealGoodsList.push(obj);
        });
        dbMarketing.postDBAddPackage(data).then(res => {
          if (res.success) {
            this.$message.success("添加成功");
            this.$router.push({
              name: "package-manage",
              params: {
                packageChange: true
              }
            });
          } else {
            this.$message.error(res.message);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.add-package {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .form {
    width: 300px;
  }
  .bottom {
    height: 40px;
    .operations {
      z-index: 10;
      height: 60px;
      position: fixed;
      left: 256px;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
      .el-button {
        width: 96px;
        letter-spacing: 4px;
      }
      .el-button + .el-button {
        margin-left: 24px;
      }
    }
  }
}
</style>
<style lang="scss">
.add-package {
  .el-table {
    .el-table__row {
      td:nth-child(8) {
        border-right: 1px solid #f2f6fc;
      }
    }
    .el-table__row:first-child {
      td:nth-child(9) {
        border-right: 1px solid #f2f6fc;
      }
    }
  }
  .el-dialog {
    border-radius: 4px;
    .el-dialog__header {
      padding: 0 16px;
      line-height: 48px;
      font-family: "PingFangSC-Medium";
      letter-spacing: 1px;
      .el-dialog__title {
        line-height: 24px;
        font-size: 16px;
        color: #606266;
      }

      .el-dialog__headerbtn {
        top: 15px;
      }
    }
    .el-dialog__body {
      padding: 0px 16px 16px 16px;
      .border {
        border-bottom: 1px solid #f7f7f7;
        margin-bottom: 16px;
      }
      .input-search {
        margin-bottom: 16px;
        .el-select {
          margin-right: 16px;
          .el-input__inner {
            width: 128px;
          }
        }
        .w160 {
          width: 160px;
          height: 32px;
          line-height: 32px;
          margin-right: 16px;
          .el-input__suffix {
            height: 40px;
            top: -3px;
            right: 0px;
          }
          .el-input__inner {
            height: 32px;
            background: rgba(234, 238, 245, 0.2);
            border: 1px solid #eaeef5;
          }
        }
        .el-input.gray {
          width: 320px;
        }
        .btn-blue {
          width: 80px;
          margin-left: 16px;
        }
      }
      .el-table {
        .el-table__header {
          .el-checkbox {
            visibility: hidden;
          }
        }
        .list {
          margin-right: 16px;
          height: 32px;
          display: flex;
          align-items: center;
          > span {
            line-height: 32px;
          }
        }
        .el-input__suffix {
          height: 40px;
          top: -1px;
          right: 0px;
        }
        .el-input__inner {
          width: 128px;
        }
      }
      .table_pagination {
        height: 56px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-pagination {
          height: 28px;
          padding: 0px;
          display: flex;
        }
      }
      #footer {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        .el-button {
          width: 80px;
          height: 32px;
          margin-left: 24px;
          line-height: 0px;
          font-size: 14px;
        }
        .el-button.btn-white {
          border: 1px solid rgba(61, 116, 242, 1);
          color: #3d74f2;
        }
        .el-button.btn-white:hover {
          border: 1px solid rgba(61, 116, 242, 0.75);
          background: rgba(61, 116, 242, 0.75);
          color: #fff;
        }
        .el-button.btn-blue {
          border: 1px solid rgba(61, 116, 242, 1);
          color: #fff;
        }
        .el-button.btn-blue:hover {
          background: rgba(55, 103, 214, 1);
          border: 1px solid rgba(55, 103, 214, 1);
          color: #fff;
        }
      }
    }
  }
}
</style>
